import { render, staticRenderFns } from "./OrgUnitItem.vue?vue&type=template&id=e4649fd2&scoped=true&lang=html&"
import script from "./OrgUnitItem.vue?vue&type=script&lang=js&"
export * from "./OrgUnitItem.vue?vue&type=script&lang=js&"
import style0 from "./OrgUnitItem.vue?vue&type=style&index=0&id=e4649fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4649fd2",
  null
  
)

export default component.exports